<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
  >
    <path d="M36.9 40C36.1 40 35.4 39.7 34.8 39.2L24.9 29.3C22.3 31.1 19.2 32 16 32C7.2 32 0 24.8 0 16C0 7.2 7.2 0 16 0C24.8 0 32 7.2 32 16C32 19.2 31.1 22.3 29.3 24.9L39.2 34.8C39.8 35.4 40.1 36.1 40 36.9C40 37.7 39.7 38.4 39.1 39C38.5 39.7 37.7 40 36.9 40ZM25 27C25.3 27 25.5 27.1 25.7 27.3L36.2 37.8C36.6 38.2 37.2 38.1 37.6 37.7C37.8 37.5 37.9 37.2 37.9 36.9C37.9 36.6 37.8 36.4 37.6 36.2L27.3 25.8C26.9 25.4 26.9 24.9 27.2 24.5C29 22 30 19.1 30 16C30 8.3 23.7 2 16 2C8.3 2 2 8.3 2 16C2 23.7 8.3 30 16 30C19 30 21.9 29 24.4 27.2L24.5 27.1C24.6 27 24.8 27 25 27Z" fill="#0F0017"/>
  </svg>
</template>
